<template>
  <div class="mcMain">
    <div class="mcDisplayMain">
      <div class="mcTopMain">
        <div class="mc" style="z-index:100">
          <div class="mcOptions">
            <div class="mcOptionsTop">
              <Dropdown class="templateSection" placeholder="Template" :items="templateList" :selectedObject.sync="templateSelected" isRequired="true"/>
              <DateTimePicker class="dateTime" title="Date" :showTime="false" :value.sync="mcDate" :isRequired="true"/>
              <InputQuery class="billCust" placeholder="Bill Cust" :items="billCustList" itemKey="Customer Code" descKey="Customer Name"
                :selectedObject.sync="billCustSelected" :isRequired="true"/>
              <InputQuery class="billCust" placeholder="Pickup" :items="pickupList" itemKey="Destination Code" 
                :selectedObject.sync="pickupSelected" :isRequired="true"/>
            </div>
            <div class="mcOptionsBtm">
              <div class="fileSelection">
                <div class="selectFilesDiv">
                  <div class="selectFilesDivDisable" v-if="selectFilesDisabled"></div>
                  <Input textType="file" class="divBtn" placeholder="Select File" id="files" ref="files" @fileChanged="importMC" />
                </div>
                <button class="sendBtn" :disabled="sendDisabled" @click="btnClick('saveBooking')">Save Booking</button>
                <div class="mcErrMsg" ref="mcErrMsg" style="background: rgba(255, 246, 121, 0.37)">{{mcErrorMsg}}</div>
              </div>
            </div>
          </div>
          <div class="mcTable">
            <div class="leftMCTable" ref="leftMCTable">
              <!-- <Tabulator class="mcLeftTable" tableID="mcTable" tableTitle="Registered Stores" :tableData="masterCountList"/> -->
              <TableBox class="mcLeftTable" tableID="mcTable" title="Registered Stores" :tableData="masterCountList" :maxSelection="-1"/>
            </div>
            <div class="rightMCTable" ref="rightMCTable" style="flex: 1; width: 50%;">
              <!-- <Tabulator class="mcLeftTable" tableID="mcTableInvalid" tableTitle="Unregistered Stores" :tableData="invalidMC"/> -->
              <TableBox class="mcLeftTable" tableID="mcTableInvalid" title="Unregistered Stores" :tableData="invalidMC" :maxSelection="-1"/>
            </div>
          </div>
          <Loader class="tableLoader" :isVisible="mcLoading" :loadingText="mcLoadingText" 
            style="position: absolute; top: 0px; height: 100%;" />
        </div>
        <div class="sliderHBarH" ref="sliderHBarH" style="margin: 0 5px;"></div>
        <div class="cmTableMain" ref="cmTableMain" style="width: 50%;">

          <!-- Unplanned Table -->
          <div class="tableDiv">
            <!-- Asigning Routes to Unplan Popup -->
            <div v-if="showUnplanPopup" class="unplanPopup">
              <div class="unplanPopupDiv">
                <div class="unplanPopupDivTitle">Plan Route</div>
                <div class="unplanPopupDivContent">
                  <div class="unplanPopupSelected">
                    <div v-for="item in unplannedSelectedList" :key="item['Dest Code']" >
                      <div class="selectedItem">
                        <div class="selectedItemDestCode">{{item['Dest Code']}}</div>
                        <div class="selectedItemName">{{item['StoreName']}}</div>
                        <div class="selectedItemZone">{{item['Zone']}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="unplanPopupDropdownDiv">
                    <div class="unplanPopupDropdownTitle">{{unplannedSelectedList.length}} Records Assigned to </div>
                    <Dropdown class="unplanPopupDropdown" placeholder="Route" :items="routesDropdown" 
                    :selectedItem="routesDropdownSelected" :search.sync="routesDropdownSearch" />
                  </div>
                  <div class="unplanPopupBtnDiv">
                    <button class="unplanPopupBtn" @click="btnClick('planConfirm')">Confirm</button>
                    <button class="unplanPopupBtn" @click="btnClick('planCancel')">Cancel</button>
                  </div>
                </div>
              </div>
            </div>


            <!-- <button id="assSaveBtn2" @click="btnClick('autoPlan')">Get Auto Plan</button> -->
            <Tabulator class="rightTable" tableID="unplannedTable" tableTitle="Unplanned" :tableData="unplannedRoutesList"
              :selectedRow.sync="unplannedSelected" :additionalColumn="unplannedTableBtn" 
              @cellButtonClick="btnClick" :hideColumns="[ '#', 'SeqNo' ]" :cellButtonMultiRow.sync="unplannedSelectedPer"/>

            <!-- <TableBox class="rightTable" tableID="unplannedTable" title="Unplanned" :tableData="unplannedRoutesList" :maxSelection="-1"
            :selectedRow.sync="unplannedSelected" :additionalButtons="unplannedTableBtn" 
              @buttonClicked="btnClick" :hideColumns="[ '#', 'SeqNo' ]" :cellButtonMultiRow.sync="unplannedSelectedPer" /> -->
          </div>

          <div class="tableDiv">
            <!-- Remove Assigned Route -->
            <div v-if="showPlanPopup" class="unplanPopup">
              <div class="unplanPopupDiv">
                <div class="unplanPopupDivTitle">Unplan Route</div>
                <div class="unplanPopupDivContent">
                  <div class="unplanPopupSelected">
                    <div v-for="item in plannedSelectedList" :key="item['Dest Code']" >
                      <div class="selectedItem">
                        <div class="selectedItemDestCode">{{item['Dest Code']}}</div>
                        <div class="selectedItemName">{{item['StoreName']}}</div>
                        <div class="selectedItemZone">{{item['Zone']}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="unplanPopupDropdownDiv">
                    <div class="unplanPopupDropdownTitle">{{plannedSelectedList.length}} Records to Remove </div>
                  </div>
                  <div class="unplanPopupBtnDiv">
                    <button class="unplanPopupBtn" @click="btnClick('unplanConfirm')">Confirm</button>
                    <button class="unplanPopupBtn" @click="btnClick('unplanCancel')">Cancel</button>
                  </div>
                </div>
              </div>
            </div>


            <Tabulator class="rightTable" tableID="routesTable" tableTitle="Planned Routes" :tableData="plannedRoutesList"
              :selectedRow.sync="plannedSelected" :additionalColumn="plannedTableBtn" 
              @cellButtonClick="btnClick" :hideColumns="[ '#' ]" :cellButtonMultiRow.sync="plannedSelectedPer" :groupBy="[ 'Route' ]" />
            
            <!-- Floating Save/Reset -->
            <div v-if="showFloatingButtons" class="floatingBtns" ref="floatingBtns" @mouseover="floatingBtnsHover(true)"  @mouseleave="floatingBtnsHover(false)"
              style="width: 40px; height: 40px; background: rgba(255,255,255,0.3); ">
              <img v-if="routesChanged" class="floatingBtnsNoti" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-notification-64.png" />
              <!-- <button class="floatingBtn" @click="btnClick('routeSave')" :disabled="!routesChanged"> -->
              <button class="floatingBtn" @click="btnClick('routeSave')">
                <img class="floatingBtnIcon" ref="floatingBtnIcon" style="width: 20px; height: 20px;"
                  src="https://dsmapi.logistics.systems/dsm6gicons/SaveStatic.png" />
                <div class="floatingBtnTitle">Save</div>
              </button>
              <button class="floatingBtn tableBtnExcel" style="margin-top: 5px;" @click="btnClick('routeSaveAndDownload')">
                <svg class="floatingBtnIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill="#169154" d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z"></path>
                  <path fill="#18482a" d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z"></path>
                  <path fill="#0c8045" d="M14 15.003H29V24.005000000000003H14z"></path>
                  <path fill="#17472a" d="M14 24.005H29V33.055H14z"></path>
                  <g>
                    <path fill="#29c27f" d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z"></path>
                    <path fill="#27663f" d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z"></path>
                    <path fill="#19ac65" d="M29 15.003H44V24.005000000000003H29z"></path>
                    <path fill="#129652" d="M29 24.005H44V33.055H29z"></path>
                  </g>
                  <path fill="#0c7238" d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"></path>
                  <path fill="#fff" d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z"></path>
                </svg>
                <!-- <img class="floatingBtnIcon" ref="floatingBtnIcon2" style="width: 20px; height: 20px;"
                  src="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" /> -->
                <div class="floatingBtnTitle">Save and Download Working Template</div>
              </button>
              <button class="floatingBtn" style="margin-top: 5px;" @click="btnClick('routeReset')">
                <img class="floatingBtnIcon" ref="floatingBtnIcon2" style="width: 20px; height: 20px;"
                  src="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" />
                <div class="floatingBtnTitle">Reset</div>
              </button>
            </div>

          </div>
          <Loader class="routeLoader" :isVisible="routeLoading" :loadingText="routeLoadingText" 
            style="position: absolute; top: 0px; height: 100%;" />
        </div>
        <input class="sliderH" ref="sliderH" type="range" min="0" max="500" value="250" @input="sliderResize" />
      </div>     
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tabulator from '@/components/Tabulator.vue';
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    Tabulator, Input, InputQuery, Dropdown, DateTimePicker, Loader,
  },
  data() {
    return {
      // Loader
      mcLoading: false,
      mcLoadingText: '',

      routeLoading: false,
      routeLoadingText: 'test',

      isDrag: false, //Resize

      // Options
      templateList: [], templateSelected: null,
      mcDate: null,
      sendDisabled: true,
      billCustList: [], billCustSelected: null,
      pickupList: [], pickupSelected: null,

      selectFilesDisabled: true,

      // Table Lists
      masterCountList: [], // Master Counting
      destList: [], // Destinations
      invalidMC: [], // Invalid Master Counting
      
      unplannedRoutesList: [], // Unplanned Routes
      plannedRoutesList: [], // Planned Routes
      // Un-Altered
      unplannedRoutesListOri: [],
      plannedRoutesListOri: [],

      // Error Msg Box
      mcErrorMsg: '',

      // Route Table Changes
      unplannedSelected: [], // Maybe not using
      unplannedSelectedPer: [], // From tabulator
      unplannedSelectedList: [], // For selection

      routesDropdown: [], // List of Routes Identified
      routesDropdownSelected: '', // String of Route Selected
      routesDropdownSearch: '',

      plannedSelected: [], // Maybe not using
      plannedSelectedPer: [], // From tabulator
      plannedSelectedList: [], // For selection

      routesChanged: false,
      showFloatingButtons: false,

      unplannedTableBtn: [ { value: 'Plan', type: 'button', index: 0 } ],   // for old Tabulator component
      // unplannedTableBtn: [ { text: 'Plan', index: 0, width: 75 } ],
      plannedTableBtn: [ 
        { value: 'Unplan', type: 'button', index: 0 },
        { value: '↑', type: 'button', index: 1 },
        { value: '↓', type: 'button', index: 2 },
      ],

      showUnplanPopup: false,
      showPlanPopup: false,
    }
  },
  props: {
  },
  async mounted() {    this.mountData();
  },
  computed: {
    topBarChange: function() {
      return [
        this.templateSelected,
        this.mcDate,
        this.billCustSelected,
        this.pickupSelected
      ]
    },
  },
  watch: {
    billCustSelected: async function() {
      if (this.billCustSelected) {
        this.mcLoadingText = 'Getting Pickup List';
        this.mcLoading = true;
        this.pickupList = await this.$apiCallV2(`/BatchOrder/GetListMaster?masterFile=PICKUP_BYCUST&cu_number=${this.billCustSelected['Customer Code'].trim()}`);
        if (this.pickupList.length == 1) { this.pickupSelected = this.pickupList[0]; }
        this.mcLoading = false;
      }
    },
    routesChanged: function() {
      var floatingBtns = this.$refs['floatingBtns'];
      var floatingBtnIcon = this.$refs['floatingBtnIcon'];
      var floatingBtnIcon2 = this.$refs['floatingBtnIcon2'];
      if (this.routesChanged) {
        floatingBtns['style']['height'] = '50px';
        floatingBtns['style']['width'] = '50px';
        floatingBtns['style']['background'] = 'white';
        floatingBtnIcon['style']['height'] = '30px';
        floatingBtnIcon['style']['width'] = '30px';
        floatingBtnIcon['src'] = 'https://dsmapi.logistics.systems/dsm6gicons/Save.gif';
        floatingBtnIcon2['style']['height'] = '30px';
        floatingBtnIcon2['style']['width'] = '30px';
      } else {
        floatingBtns['style']['height'] = '40px';
        floatingBtns['style']['width'] = '40px';
        floatingBtns['style']['background'] = 'rgba(255,255,255,0.3)';
        floatingBtnIcon['src'] = 'https://dsmapi.logistics.systems/dsm6gicons/SaveStatic.png';
        floatingBtnIcon['style']['height'] = '20px';
        floatingBtnIcon['style']['width'] = '20px';
        floatingBtnIcon2['style']['height'] = '20px';
        floatingBtnIcon2['style']['width'] = '20px';
      }
    },
    masterCountList: function() {
      this.sendDisabled = this.masterCountList.length > 0 ? false : true;
    },
    topBarChange: function() {
      if ( this.templateSelected && this.mcDate && this.billCustSelected && this.pickupSelected) {
        this.selectFilesDisabled = false;
        if (this.masterCountList.length > 0) { this.sendDisabled = false; }
      } else { 
        this.selectFilesDisabled = true; 
        this.sendDisabled = true;
      }
    },
  },
  methods: {
    floatingBtnsHover: function(btn) {
      var floatingBtns = this.$refs['floatingBtns'];
      if (this.routesChanged) {
        floatingBtns['style']['width'] = btn ? '300px' : '50px';
        floatingBtns['style']['height'] = btn ? '105px' : '50px';
      } else {
        floatingBtns['style']['width'] = btn ? '300px' : '40px';
        floatingBtns['style']['height'] = btn ? '105px' : '40px';
      }
    },
    btnClick: async function(btn, row) {
      switch(btn){
        case 'saveBooking':
          this.unplannedRoutesList = [];
          var fullCOMBooking = await this.getFullCOMBooking();
          if (fullCOMBooking.length < 1) {
            let count = 1;
            this.mcLoading = true;
            for (let m of this.masterCountList) {
              this.mcLoadingText = `Saving ${count} of ${this.masterCountList.length}`;
              await this.saveCOMBooking(m, 'N');
              count++;
            }
            this.mcLoading = false;
            this.getAutoPlannedRoutes();
            this.errorBoxColor('Success','Successfully saved booking.');

            // Below line is calling the getAutoPlannedRoutes method before save is completed
            // this.masterCountList.forEach((m)=> { this.saveCOMBooking(m,'N'); })
            // this.$nextTick(() => {
            //   this.mcLoading = false;
            //   this.getAutoPlannedRoutes();
            // })
          } else {
            var isSave = await this.$showAlert('warning', 'Record already exist!', `Are you sure you want to override previous record?`, [{'text': 'Override'}, {'text': 'Cancel'}]);
            if (isSave === "Override") {
              let count = 1;
              for (let m of this.masterCountList) {
                this.mcLoadingText = `Saving ${count} of ${this.masterCountList.length}`;
                this.mcLoading = true;
                var foundList = fullCOMBooking.filter((b) => { return b['DropOff'].trim() == m['StoreCode'].trim()})
                if (foundList.length > 0) {
                  await this.saveCOMBooking(m,'E',foundList[0]['ID'], foundList[0]['AutoRequestNo'], foundList[0]['SeqNo']);
                } else {
                  await this.saveCOMBooking(m,'N');
                }
                count++;
              }
              this.mcLoading = false;
              this.getAutoPlannedRoutes();
              // Below line is calling the getAutoPlannedRoutes method before save is completed
              // this.masterCountList.forEach(async (m) => {
              //   this.mcLoadingText = 'Saving';
              //   this.mcLoading = true;
              //   var foundList = fullCOMBooking.filter((b) => { return b['DropOff'].trim() == m['StoreCode'].trim() })
              //   if (foundList.length > 0) {
              //     await this.saveCOMBooking(m,'E',foundList[0]['ID']);
              //   } else {
              //     await this.saveCOMBooking(m,'N');
              //   }
              // });
              // this.$nextTick(() => {
              //   this.mcLoading = false;
              //   this.getAutoPlannedRoutes();
              // })
            }
          }
          break;

        // Assigning
        case 'Plan':
          this.$nextTick(() => {
            this.unplannedSelectedList = [];
            if (this.unplannedSelectedPer.length > 0) {
              this.unplannedSelectedList = this.unplannedSelectedPer.slice(0);
            } else {
              this.unplannedSelectedList.push(row);
            }
            this.showUnplanPopup = true;
          })
          break;
        case 'planConfirm':
          if (this.routesDropdownSearch != '' && this.routesDropdownSearch != undefined) {
            this.editRoutes('assign', this.unplannedSelectedList, this.unplannedRoutesList, this.plannedRoutesList);
            this.showUnplanPopup = false;
          }
          break;
        case 'planCancel':
          this.showUnplanPopup = false;
          break;
        case '↑':
          this.editSequence('up',row);
          break;
        case '↓':
          this.editSequence('down',row);
          break;
        // Assigning
          
        // Unassigning
        case 'Unplan':
          this.$nextTick(() => {
            this.plannedSelectedList = [];
            if (this.plannedSelectedPer.length > 0) {
              this.plannedSelectedList = this.plannedSelectedPer.slice(0);
            } else {
              this.plannedSelectedList.push(row);
            }
            this.showPlanPopup = true;
          })
          break;
        case 'unplanConfirm':
          this.editRoutes('remove', this.plannedSelectedList, this.plannedRoutesList, this.unplannedRoutesList);
          this.showPlanPopup = false;
          break;
        case 'unplanCancel':
          this.showPlanPopup = false;
          break;
        // Unassigning

        // Routes Floating Buttons
        case 'routeSave':
          this.saveAutoPlannedRoutes();
          break;
        case 'routeSaveAndDownload':
          await this.saveAutoPlannedRoutes();
          this.excelClicked();
          break;
        case 'routeReset':
          this.unplannedRoutesList = this.unplannedRoutesListOri.slice(0);
          this.plannedRoutesList = this.plannedRoutesListOri.slice(0);
          this.routesChanged = false;

          this.unplannedRoutesList.forEach(u => {
            u['Route'] = 'unplanned';
          });
          break;
      }
    },

    getFullCOMBooking: async function() {
      this.mcLoadingText = 'Checking for Previous Records';
      this.mcLoading = true;
      var dataToPost = {
        'indicator': 'U',
        'cu_number': this.billCustSelected['Customer Code'].trim(),
        'billto': this.billCustSelected['Customer Code'].trim(),
        'autorequestno': '',
        'startdate': this.getDate(this.mcDate),
        'enddate': this.getDate(this.mcDate),
        'serachbyuserid': '',
      };

      var dataUpdate = dataToPost;
      var postUpdate = await this.$apiCallV2('/BatchBooking/GetFullCOMBooking', dataUpdate);
      this.mcLoading = false;
      return postUpdate;
    },

    excelClicked: function() {
      if (this.plannedRoutesList.length > 1) {
        //---- Generate new Workbook with Empty Worksheet
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.aoa_to_sheet([]);
        XLSX.utils.book_append_sheet(wb, ws, 'Working Template');

        //---- Format worksheet
        var wscols = [
          {wch:13.43},
          {wch:9.71},
          {wch:9.71},
          {wch:19.71},
          {wch:72.43},
        ];
        ws['!cols'] = wscols;

        //---- Set Title of Worksheet
        let value = 'Tuck Sun Logistics';
        let cell = 'A2';
        XLSX.utils.sheet_add_aoa(ws, [[value]], { origin: cell });

        let startRow = 4;
        let columnNames = [ 'Store', 'Totes', 'Carton', 'Store Name', 'Address' ];

        let plannedData = this.plannedRoutesList.filter(t => t['#'] != 0);
        let allRoutes = [... new Set(plannedData.map(p => parseInt(p['Route'])))].sort((a, b) => { return a - b });

        for (let r of allRoutes) {
          let routeData = plannedData.filter(p => p['Route'] == r);

          XLSX.utils.sheet_add_aoa(ws, [ [ `Route ${r}`, `${routeData.length} Stores` ] ], { origin: `A${startRow}` });
          
          startRow++;
          XLSX.utils.sheet_add_aoa(ws, [columnNames], { origin: `A${startRow}` });
          let totalTB = 0;
          let totalCTN = 0;
          routeData.forEach((rd) => {
            let tb = rd['TB'] ? parseInt(rd['TB']) : 0;
            let ctn = rd['CTN'] ? parseInt(rd['CTN']) : 0;

            let rowData = [
              rd['Dest Code'] ? rd['Dest Code'].trim() : '',
              tb,
              ctn,
              rd['StoreName'] ? rd['StoreName'].trim() : '',
              rd['Address'] ? rd['Address'].trim() : ''
            ];
            startRow++;
            XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: `A${startRow}` });

            totalTB += tb;
            totalCTN += ctn;
          });
          
          startRow++;
          XLSX.utils.sheet_add_aoa(ws, [[ '', totalTB, totalCTN, totalTB + totalCTN ]], { origin: `A${startRow}` });

          startRow += 2;
        }
        
        XLSX.writeFile(wb, "WorkingTemplate.xlsx");
      } else {
        this.$showAlert('error', 'Cannot Create Working Template', 'To create working template, the planned routes cannot be empty');
      }
    },

    // Edit Route Tables                                                        // editRoutes('assign', this.unplannedSelectedList, this.unplannedRoutesList, this.plannedRoutesList);
    editRoutes: function(action, selectedList, tableList, tableListOpp) {
      this.routeLoadingText = 'Editing Routes';
      this.routeLoading = true;
      selectedList.forEach((r) => {
        var ii = -1;
        tableList.forEach((rr, i) => { if (rr == r) {ii=i} })
        if (ii != -1) { tableList.splice(ii,1); }
        r['Route'] = action == 'assign' ? this.routesDropdownSearch : 'unplanned';

        // Assigning Sequence number
        var sameRouteList = tableListOpp.filter((rr) => { return rr['Route'].trim() == r['Route'].trim() });
        if (action == 'assign' && sameRouteList.length > 0) {
          var maxRouteSeq = Math.max.apply(Math, sameRouteList.map((rr) => { return rr['SeqNo'] }))
          r['SeqNo'] = maxRouteSeq + 1;
        } else {
          r['SeqNo'] = 1;
        }
        tableListOpp.push(r);
      });

      if (action == 'remove') {
        tableList.forEach((t, i) => {
          if (i > 0) {
            t['SeqNo'] = i;
          }
        });
      }

      this.routesChanged = true;
      this.routeLoading = false;

      this.$nextTick(() => {
        if (action == 'assign' && this.plannedRoutesList.length > 1) {
          this.plannedRoutesList = this.plannedRoutesList.sort((a,b) => parseInt(a['Route']) - parseInt(b['Route']));
        }
      });
    },
    editSequence: function(action, row) { // Need Optimisation
      // Limit if first/last
      this.routeLoadingText = 'Editing Route';
      var sameRouteList = [];
      this.plannedRoutesList.forEach((r,i) => {
        if (r['Route'] == row['Route']) { 
          var newObject = Object.assign({},r);
          newObject['index'] = i;
          sameRouteList.push(newObject); 
        }
      })
      var maxRouteSeq = Math.max.apply(Math, sameRouteList.map((r) => { return r['SeqNo'] }))
      if (action == 'up' && row['SeqNo'] != 1) {
        this.routeLoading = true;
        var selectedIndex = sameRouteList.filter((r) => { return r['SeqNo'] == row['SeqNo'] })
        var replaceIndex = sameRouteList.filter((r) => { return r['SeqNo'] == row['SeqNo']-1 })
        
        var selectedObject = Object.assign({}, this.plannedRoutesList[selectedIndex[0]['index']]);
        selectedObject['SeqNo'] = row['SeqNo']-1;
        var replaceObject = Object.assign({}, this.plannedRoutesList[replaceIndex[0]['index']]);
        replaceObject['SeqNo'] = row['SeqNo'];

        this.plannedRoutesList.splice(replaceIndex[0]['index'], 2, selectedObject, replaceObject);
        this.routesChanged = true;
        this.routeLoading = false;
      } else if (action == 'down' && row['SeqNo'] != maxRouteSeq) {
        this.routeLoading = true;
        var selectedIndex = sameRouteList.filter((r) => { return r['SeqNo'] == row['SeqNo'] })
        var replaceIndex = sameRouteList.filter((r) => { return r['SeqNo'] == row['SeqNo']+1 })

        var selectedObject = Object.assign({}, this.plannedRoutesList[selectedIndex[0]['index']]);
        selectedObject['SeqNo'] = row['SeqNo']+1;
        var replaceObject = Object.assign({}, this.plannedRoutesList[replaceIndex[0]['index']]);
        replaceObject['SeqNo'] = row['SeqNo'];

        this.plannedRoutesList.splice(selectedIndex[0]['index'], 2, replaceObject, selectedObject);
        this.routesChanged = true;
        this.routeLoading = false;
      }

    },

    importMC: function(fileFiles) {
      this.errorBoxColor('Plain');
      if (!fileFiles) {
        return;
      }

      this.mcLoadingText = 'Reading File';
      this.mcLoading = true;

      let uploadedFiles = fileFiles;
      var f = uploadedFiles[0];      
      var fileType = f.name.split('.');
      //console.log(fileType);
      if (fileType[1] == 'xlsx') {
        var reader = new FileReader();
        reader.onload = (e) => {
          var data = e.target.result;
          data = new Uint8Array(data);
          var workbook = XLSX.read(data, {
            type: "array"
          });
          var worksheet = workbook.Sheets['Raw'];

          if (worksheet == undefined) {
            this.errorBoxColor('Error', 'Please import the correct "Master Counting" excel file.')
          } else {
            var mcList = XLSX.utils.sheet_to_json(worksheet, { raw:true, defval:null });

            // Filter for watson
            try {
              this.invalidMC = [];
              this.masterCountList = [];
              this.mcLoadingText = 'Loading Table';
              mcList.forEach((m, i) => {
                if (m['STORE_CODE'] != undefined) {
                  var wStore = this.destList.filter((w) => {
                    return m['STORE_CODE'].trim() == w['Destination Code'].trim();
                  })
                  if (wStore.length > 0) {
                    var objToPush = {
                      'StoreCode': m['STORE_CODE'],
                      'StoreName': wStore[0]['Company'],
                      'Address': wStore[0]['Address'],
                      'AreaCode': wStore[0]['Area Code'],
                      'AreaName': wStore[0]['Area Name'],
                      'ZoneCategory': wStore[0]['ZoneCategory'],
                      'ZoneType': wStore[0]['ZoneType'],
                      'TotalTB': m['TOTAL_TB'],
                      'TotalCTN': m['TOTAL_CTN'],
                    };
                    this.masterCountList.push(objToPush);
                  } else { this.invalidMC.push(m); }
                }
              })

            } catch (e) {console.log(e);}

            this.mcLoadingText = 'Posting Data';
            this.errorBoxColor('Plain');
          }
          this.mcLoading = false;
        }
        try {
        reader.readAsArrayBuffer(f);
        } catch (e) {
          console.log(e);
          this.mcErrorMsg = 'Error Getting from Excel File';
        }
      } else {
        this.errorBoxColor('Error', 'Please import the correct "Master Counting" excel file.');
        this.mcLoading = false;
      }
    },
    saveCOMBooking: async function(mStore, action, id, autorequestno, seqno) {
      // Loop thru destination
      var retrievedDest = await this.$apiCallV2(`/DestinationList/GetDetailsMaster?recordID=${mStore['StoreCode']}`);

      var consginmentsToPost = [
        {
          'id': id ? id : '',
          'seqno': seqno ? seqno : '', 
          'packageqty': mStore['TotalTB'] + mStore['TotalCTN'],
          'package_code':'', 
          'packageweight':'', 
          'packagem3':'', 
          'packageheight':'',
          'packagewidth':'',
          'packagelength':'',
          'subpackageqty':mStore['TotalTB'],
          'subpackagecode':'',
          'subpackageweight':mStore['TotalCTN'],
          'subpackagem3':'',
          'total_charges':'',
          'actual_charges':'',
          'prod_txnid':'',
          'itemtype':'',
          'remarks1': `Total TB:${mStore['TotalTB']}, Total CTN:${mStore['TotalCTN']}`,
          'remarks2': `Total TB:${mStore['TotalTB']}, Total CTN:${mStore['TotalCTN']}`,
        }
      ];
      var dataToPost = {
        'action': action,
        'cu_number': this.billCustSelected['Customer Code'].trim(),
        'cmr_no':'',
        'job_no':'',
        'job_date':this.getDate(this.mcDate),
        'job_type':'D',
        'vessel_name':'',
        'voyno':'',
        'shipcall_no':'',
        'shipline':'',
        'urgent':'',
        'imp_port':'',
        'imp_portname':'',
        'load_port':'',
        'load_portname':'',
        'trans':'',
        'trans_port':'',
        'trans_portname':'',
        'operator_code':'',
        'operator_name':'',
        'currency':'',
        'spc_treatment':'',
        'ag_code':'',
        'ag_name':'',
        'ag_sname':'',
        'frtship_name':'',
        'discharge_port':'',
        'discharge_portname':'',
        'date_eta':'',
        'date_etd':'',
        'datedemurage':'',
        'datedetention':'',
        'bookingrefno':'',
        'finaldest':'',
        'daterequired':'',
        'timerequired':'',
        // 'pickup':'WSONPC',
        'pickup': this.pickupSelected['Destination Code'].trim(),
        'dropoff': mStore['StoreCode'].trim(),
        'trip':'',
        'destination_code':'',
        'company':'',
        'addr1':'',
        'addr2':'',
        'addr3':'',
        'addr4':'',
        'phone':'',
        'attn':'',
        'fax':'',
        'contline':'',
        'contoperator':'',
        'commodity':'',
        'totalcont':'',
        'requestno':'',
        'daterequest':'',
        'requestedby':'',
        'curefno':'',
        'closingtime':'',
        'cont_no':'',
        'size':'',
        'cont_type':'',
        'type':'',
        'deliverytype':'',
        'handlingtype':'',
        'seal_no':'',
        'gweight':'',
        'measurement':'',
        'temperature':'',
        'height':'',
        'reqtimedesc':'',
        'officehrs':'',
        'fumigation':'',
        'description':'',
        'indicator':'U',
        'datereceived':'',
        'timereceived':'',
        'dateupdate':'',
        'timeupdate':'',
        'orderno':'',
        'cu_name':'',
        'senderco':'',
        'cu_addr1':'',
        'cu_addr2':'',
        'cu_addr3':'',
        'cu_addr4':'',
        'postcode':'',
        'city':'',
        'state':'',
        'country':'',
        'cu_phone':'',
        'cu_fax':'',
        'pickup_company':'',
        'pickup_addr1':'',
        'pickup_addr2':'',
        'pickup_addr3':'',
        'pickup_addr4':'',
        'pickup_city':'',
        'pickup_state':'',
        'pickup_country':'',
        'pickup_phone':'',
        'pickup_fax':'',
        'pickup_postcode':'',
        'pickup_attn':'',
        'pickup_chamareacode':'',
        'pickup_email':'',
        'pickup_daterequiredfrom':'',
        'pickup_timerequiredfrom':'',
        'pickup_daterequiredto':'',
        'pickup_timerequiredto':'',
        'sendto_company':'',
        'sendto_addr1':'',
        'sendto_addr2':'',
        'sendto_addr3':'',
        'sendto_addr4':'',
        'sendto_city':'',
        'sendto_state':'',
        'sendto_country':'',
        'sendto_phone':'',
        'sendto_fax':'',
        'sendto_postcode':'',
        'sendto_attn':'',
        'dropoff_company': retrievedDest.Destination['Company'],
        'dropoff_addr1': retrievedDest.Destination['Addr1'],
        'dropoff_addr2': retrievedDest.Destination['Addr2'],
        'dropoff_addr3': retrievedDest.Destination['Addr3'],
        'dropoff_addr4': retrievedDest.Destination['Addr4'],
        'dropoff_city': retrievedDest.Destination['City'],
        'dropoff_state': retrievedDest.Destination['State'],
        'dropoff_country': retrievedDest.Destination['Country'],
        'dropoff_phone': retrievedDest.Destination['Phone'],
        'dropoff_fax': retrievedDest.Destination['Fax'],
        'dropoff_postcode': retrievedDest.Destination['PostCode'],
        'dropoff_attn': retrievedDest.Destination['Attn'],
        'dropoff_chamareacode': '',
        'dropoff_email': retrievedDest.Destination['Email'],
        'dropoff_daterequiredfrom':'',
        'dropoff_timerequiredfrom':'',
        'dropoff_daterequiredto':'',
        'dropoff_timerequiredto':'',
        'handlingtypedesc':'',
        'deliverytypedesc':'',
        'offloadatpremis':'',
        'frtship_no':'',
        'autorequestno': autorequestno ? autorequestno : '',
        'cnjobtype':'',
        'sendto_chamareacode':'',
        'bookingsource':'W',
        'billto': this.billCustSelected['Customer Code'].trim(),
        'securedpremises':'',
        'letterofundertaking':'',
        'rfcofficehrs':'',
        'cu_contact':'',
        'cu_department':'',
        'vehiclecategory':'',
        'services':'',
        'system':'TMS',
        'packmaterial':'',
        'mvshipcallno':'',
        'jobformtype':'',
        'senderemail':'',
        'getautorequestno':'1',
        'recguid':'',
        'consignments':consginmentsToPost, 
      };
      try {
        var dataUpdate = dataToPost;
        var postUpdate = await this.$apiCallV2('/BatchBooking/SaveComBooking', dataUpdate);
      } catch (e) {
        console.log('Saving Error');
        console.log(e);
      }


    },
    getAutoPlannedRoutes: async function() {
      this.routeLoadingText = 'Getting Routes';
      this.routeLoading = true;
      this.routesChanged = false;
      var dataToPost = {
        // 'cu_number' : 'WSON',
        // 'jobdate' : '2021-04-01',
        'cu_number' : this.billCustSelected['Customer Code'].trim(),
        'jobdate' : this.getDate(this.mcDate),
        'maxstore' : 10,
        'maxitems' : 250,
        'template' : 'WATSON',
        'system' : 'TMS',
        'action' : '',
        'store' : [],
      };

      try {
        var dataUpdate = dataToPost;
        // console.log(dataUpdate);
        var postUpdate = await this.$apiCallV2('/BatchBooking/GetAutoPlannedRoutes', dataUpdate);
        // console.log(postUpdate);

        var specialRoutes = postUpdate.PlannedRoute.Stores.reduce((i,d) => {
          if (!i[d['Route']]) {  
            i[d['Route']] = [];
          }

          i[d['Route']].push(d);
          return i;
        }, {})
        delete specialRoutes['unplanned'];

        this.routesDropdown = [];
        for (let route in specialRoutes) {
          this.routesDropdown.push(route);
        }
        //console.log(this.routesDropdown);

        this.unplannedRoutesList = [];
        this.plannedRoutesList = [];
        this.unplannedRoutesListOri = [];
        this.plannedRoutesListOri = [];
        this.$nextTick(() => {
          var seqnoPlanned = 1;
          var prevRoute = '';
          postUpdate.PlannedRoute.Stores.forEach((s) => {
            if (s.Route.trim() == 'unplanned') {
              s['SeqNo'] = '';
              this.unplannedRoutesList.push(s);
              this.unplannedRoutesListOri.push(s);
            } else {
              seqnoPlanned = prevRoute != s['Route'] ? 1 : seqnoPlanned;
              s['SeqNo'] = seqnoPlanned;
              seqnoPlanned += 1;
              this.plannedRoutesList.push(s);
              this.plannedRoutesListOri.push(s);
              prevRoute = s['Route'];
            }
          })

          // console.log(this.unplannedRoutesList);
          // console.log(this.unplannedRoutesListOri);
          
          // let temp = [];
          // this.unplannedRoutesList.forEach((c) => {
          //   if (!temp.includes(c)) {
          //     temp.push(c);
          //   }
          // });
          // this.unplannedRoutesList = temp;
          // temp = [];
          // this.unplannedRoutesListOri.forEach((c) => {
          //   if (!temp.includes(c)) {
          //     temp.push(c);
          //   }
          // });
          // this.unplannedRoutesListOri = temp;

          // console.log(this.unplannedRoutesList);
          // console.log(this.unplannedRoutesListOri);

          var tableType = {
            '#': 0,
            'SeqNo': 'number',
            'Route': 'string',
            'Area': 'string',
            'Zone': 'string',
            'Dest Code': 'string',
            'StoreName': 'string',
            'Address': 'string',
            'Job Type': 'string',
            'TB': 'number',
            'CTN': 'number',
            'TB+CTN': 'number',
          };
          this.plannedRoutesList.splice(0,0, tableType);
          this.plannedRoutesListOri.splice(0,0, tableType);
          this.unplannedRoutesList.splice(0,0, tableType);
          this.unplannedRoutesListOri.splice(0,0, tableType);

          this.routeLoading = false;
          this.showFloatingButtons = true;
        })
      } catch (e) {
        this.routeLoading = false;
        console.log('Saving Error');
        console.log(e);
      }
    },
    saveAutoPlannedRoutes: async function() {
      this.routeLoadingText = 'Saving Routes';
      this.routeLoading = true;
      var fullRouteList = this.plannedRoutesList.slice(0);
      fullRouteList.splice(0,1);
      var fullRouteList2 = this.unplannedRoutesList.slice(0);
      fullRouteList2.splice(0,1);
      var fullRoute = fullRouteList.concat(fullRouteList2);
      
      var destStore = [];
      fullRoute.forEach((r) => {
        var routeObj = {
          'destination_code': r['Dest Code'].trim(),
          'destinationroute': r['Route'],
          'destinationseqno': r['SeqNo'],
        }
        destStore.push(routeObj);
      })

      var dataToPost = {
        // 'jobdate' : '2021-04-01',
        // 'cu_number' : 'WSON',
        'jobdate' : this.getDate(this.mcDate),
        'cu_number' : this.billCustSelected['Customer Code'].trim(),
        'maxstore' : 10,
        'maxitems' : 250,
        'template' : 'WATSON',
        'system' : 'TMS',
        'action' : 'N',
        'store' : destStore,
      };

      var dataUpdate = dataToPost;
      // console.log(dataUpdate);
      var postUpdate = await this.$apiCallV2('/BatchBooking/GetAutoPlannedRoutes', dataUpdate);
      // console.log(postUpdate);

      this.$nextTick(() => {
        if (postUpdate[0]['ErrMsg'] == '') {
          this.errorBoxColor('Success','Successfully saved routes.');
        } else {
          this.errorBoxColor('Error','Something went wrong, not saved.')
        }
        this.routeLoading = false;
      })

    },


    // Mount Initial Data
    mountData: async function() {
      this.mcLoadingText = 'Getting Initial Data';
      this.mcLoading = true;
      try {
      this.templateList = await this.$apiCallV2('/BatchOrder/GetListMaster?masterFile=TEMPLATE_TMSJOB');

      this.destList = await this.$apiCallV2('/Master/GetListMaster', { masterfile : 'destination' });

      // this pickupList = await this.$apiCallV2('/BatchBooking/GetListMaster?masterFile=pickup');

      this.billCustList = await this.$apiCallV2('/BatchBooking/GetListMaster?masterFile=billcust');

      this.getDateTmr();

      this.mountDefault();
      this.mcLoading = false;
      } catch (e) {
        console.log(e)
        console.log('something went wrong, please refresh');
        this.errorBoxColor('Error', 'Something went wrong, please refresh.');
      }
    },
    mountDefault: function() {
      if (this.templateList.length == 1) { this.templateSelected = this.templateList[0]; }
      if (this.billCustList.length == 1) { this.billCustSelected = this.billCustList[0]; }
    },
    getDateTmr: function() {
      var tmr = new Date();
      tmr.setDate(new Date().getDate()+1);
      this.mcDate = tmr;
    },

    // Show/Hide Invalid Stores List
    showHideInvalid: function(action) {
      var rightMCTable = this.$refs['rightMCTable'];
      switch (action) {
        case 'show':
          rightMCTable['style']['width'] = 'auto';
          rightMCTable['style']['flex'] = '1';
          break;
        case 'hide':
          rightMCTable['style']['width'] = '0%';
          rightMCTable['style']['flex'] = '0';
          break;
      };
    }, 
    // Slider
    sliderResize: function() {
      var table = this.$refs['cmTableMain'];
      var sliderH = this.$refs['sliderH'];
      table['style']['width'] = (100 - (sliderH['value'] / 5)) + '%';
    },
    getDate: function(dateTime){
      var dd = String(dateTime.getDate()).padStart(2,'0');
      var mm = String(dateTime.getMonth() + 1).padStart(2,'0');
      var yyyy = dateTime.getFullYear();

      return [yyyy,mm,dd].join('-');
    },
    errorBoxColor: function(status, msg) {
      var errorBox = this.$refs['mcErrMsg'];
      switch(status) {
        case 'Plain':
          errorBox['style']['background'] = 'rgba(255, 246, 121, 0.37)';
          break;
        case 'Success':
          errorBox['style']['background'] = 'rgba(126, 255, 121, 0.37)';
          break;
        case 'Error':
          errorBox['style']['background'] = 'rgba(255, 121, 121, 0.37)';
          break;
      }
      this.mcErrorMsg = msg != '' ? msg : '';
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";

*, body, html {
  box-sizing: border-box;
}

.mcMain {
  width: 100%;
  height: 100%;
  padding: 3px 3px 3px 45px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mcDisplayMain {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.mcTopMain {
  width: 100%;
  height: auto;
  flex: 1;
  margin: 0 0 4px 0;  
  position: relative;
  display: flex;
  justify-content: space-between;
  z-index: 2;
}

.sliderH {
  width: 100%;
  height: 100%;
  position: absolute;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent;
  outline: none;
  cursor: ew-resize;
}

.sliderH::-webkit-slider-thumb {
  width: 1px;
  height: 1px;
  -webkit-appearance: none;
  background-color: #0000;
  background: #0000;
  border: none;
}

.sliderH::-moz-range-thumb {
  -moz-appearance: none;
  background-color: #0000;
  background: #0000;
  border: none;
}

.sliderHBarH {
  width: 3px;
  height: 100%;
  background-color: #333;
  border: solid 1px #333;
  pointer-events: none;
  z-index: 1;
}

.cmTableMain {
  height: 100%;
  border-right: solid 1px #999;
  overflow: hidden;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.mc {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  border-left: solid 1px #999;
  overflow: hidden;
  z-index: 1;
  flex: 1;
}

.rightTable {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0px;
  bottom: 37px;
  left: 0px;
  right: 0px;
}

.mcLeftTable {
  width: 90%;
  padding: 0 10px 10px 10px;
  border-radius: 5px;
  bottom: 37px;
  top: 0px;
  height: auto;
  position: absolute;
  // left: 0px;
  // right: 0px;
  overflow: auto;
}

.rightMCTable {
  height: 100%;
  position: relative;
  display: flex;
  flex: 1;
}


.mcTable {
  display: flex;
  flex: 1;
  width: auto;
  position: relative;
  margin-left: 10px;
}

.tableDiv {
  position: relative;
  height: 50%;
  width: 100%;
  bottom: 0px;
  margin: 5px;
}

.mcTableDiv {
  // position: relative;
  height: 100%;
  bottom: 0px;
}

.rightMCTable, .leftMCTable {
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  width: auto;
  height: 100%;
  flex: 1;
  white-space: normal !important;
}

.rightMCTable {
  margin-left: 10px;
}

.mcOptions {
  width: 98%;
  background: white;
  border-radius: 5px;
  margin: 10px 30px 10px 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.mcOptionsTop {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.templateSection {
  width: 100px;
}

.billCust {
  width: 40%;
}

.tableBtn {
  // background: green;
  width: 100%;
  height: 37.99px;
  z-index: 1;
  display: flex;
  flex-direction: row;
  position: absolute;
  z-index: 1;
}

.tableBtnExcel {
  padding: 4px;
  // position: absolute;
  // top: 0px;
  // left: 100px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 20;
}

.tableBtnExcel > svg {
  width: 20px;
  height: 20px;
}

.tableBtnLabel {
  width: auto;
  height: 100%;
  margin: 0 0 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#tableBtnPlanned {
  padding: 5px 0 5px 200px;
}

.tableBtnBtn {
  margin: 0 5px;
}

.tableBtnAssRoute {
  // background: white;
  display: flex;
  flex-direction: row;
}

#routeDropdown {
  background: white;
  width: 100px;
}


// Floating Save/Reset
.floatingBtns, .floatingBtnIcon {
  transition: 0.5s;
}
.floatingBtns {
  position: absolute;
  z-index: 1;
  right: 0;
  top: 0;
  overflow: hidden;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
}
.floatingBtnsNoti{
  position: absolute;
  top: 0;
  left: 0;
  width: 25px;
  height: 25px;
  border-radius: 50%;
}
.floatingBtn {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.floatingBtnTitle {
  height: 100%;
  width: auto;
  flex: 1;
  overflow: hidden;
}
#floatingBtnSaveDiv {
  bottom: 0;
  position: absolute;
}
// Floating Buttons

#assBtn, #assSaveBtn, #assSaveBtn2 {
  position: absolute;
  top: 5px;
  z-index: 1;
}

#assBtn {
  left: 270px;
}

#assSaveBtn {
  left: 150px;
}

#assSaveBtn2  {
  left: 400px;
}

.divBtn {
  width: 100%;
  height: 100px;
}

.divBtn .button {
  height: 50px;
}

.mcErrMsg {
  display: flex;
  flex: 1;
  height: 40px;
  margin: 0px 10px;
}

.fileSelection {
  display: flex;
  flex-direction: row;
}

.sendBtn {
  height: 27.5px;
  margin: 0 5px;
}


// Unplan Popup Route Selection
.unplanPopup {
  position: absolute;
  top: 38px;
  bottom: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  display: flex;
  align-items: center;
}
.unplanPopupDiv {
  background: white;
  border-radius: 5px;
  width: 50%;
  height: 80%;
  margin: auto;
}
.unplanPopupDivTitle {
  border-bottom: 2px solid #b4b4b4;
  padding: 10px;
  font-family: 'Roboto Mono', monospace;
  font-weight: bold;
  line-height: 1.5;
}
.unplanPopupDivContent {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 80%;
}
.unplanPopupSelected {
  border: solid 1px black;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height  : 60px;
  padding: 0;
}
.selectedItem {
  // border: solid 1px gray;
  display: flex;
  justify-content: space-between;
  padding: 0 5px;
  height: 20px;
}
.selectedItemDestCode {
  width: 10%;
}
.selectedItemName {
  width: 70%;
}
.selectedItemZone {
  width: 20%;
}
.unplanPopupDropdownDiv {
  display: flex;
  justify-content: center;
}
.unplanPopupDropdownTitle {
  text-align: right;
  height: 25px;
  margin: 2px 0;
  padding-right: 10px;
  display: flex;
  justify-content: flex-end;
}
.unplanPopupDropdown {
  width: 40%;
}
.unplanPopupBtnDiv {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.unplanPopupBtn {
  margin: 5px;
}


// File Select
.selectFilesDiv {
  position: relative;
  width: 30%;
}

.selectFilesDivDisable {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 10;
}
</style>
